import { useEffect, useRef, useState } from 'react';
import './reviewBookSumm.css';
import { ReactComponent as Chevron } from '../../../../assets/icons/trvto_downArrow.svg';
import { getHikedPrice } from '../../../../utils/getAmountWithTransaction';
import offerApplyTrip from '../../../tripDetails/tripBookingTab/tripBookingTabFun/offerApplyTrip';
import { toast } from 'react-toastify';
import Remove from '../../../../assets/icons/trvto_close-rounded.svg';
import { calculatePayment } from '../../../../utils/calculatePayment';

export default function ReviewBookSumm({
    setBookingData,
    bookingData,
    reviewConfirm,
    loggedInUser,
    setNavDetails,
    paymentType,
    setOfferType,
    handleCashOrCoins,
    selectedType,
    setSelectedType,
    amount,
    setAmount,
    cashToRedeem,
    setCashToRedeem,
    setPaymentType,
    isAuthenticated,
    handleApplyOffer,
    handleRemoveOffer
}) {
    const bookingTabRef = useRef(null);
    const [offerCode, setOfferCode] = useState('');
    const [isCashCoin, setIsCashCoin] = useState(bookingData.offerType === 'cashOrcoin' ? true : false);
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpand = (e) => {
        setIsExpanded(!isExpanded);
    };

    const paymentBreakdown = calculatePayment({
        bookingData,
        paymentType,
        offerAmo: bookingData.offerAmo,
        cashToRedeem
    });

    const { finalPayable, reservePrice, convenienceFee, offerAmount, remainingAmount, reserveConvenienceFee } =
        paymentBreakdown;

    const prev = useRef(isExpanded);

    useEffect(() => {
        // scroll only if user toggled from collapsed → expanded
        const userExpanded = !prev.current && isExpanded;

        if (userExpanded && bookingTabRef.current) {
            window.scrollTo({
                top: bookingTabRef.current.offsetTop - 100,
                behavior: 'smooth'
            });
        }

        // update prev value
        prev.current = isExpanded;
    }, [isExpanded]);

    useEffect(() => {
        setIsCashCoin(bookingData.offerType === 'cashOrcoin' ? true : false);
        setOfferCode('');
    }, [bookingData.offerType]);

    function handlePromoCode(e) {
        const capOffer = e.target.value.toUpperCase();
        setOfferCode(capOffer);
    }

    const resetOffers = () => {
        setOfferCode('');
        setIsCashCoin(false);
        setCashToRedeem(0);
        setAmount(0);
        setSelectedType('');

        setBookingData((prev) => ({
            ...prev,
            offerCode: '',
            offerData: {},
            offerApplied: false,
            offerAmo: 0,
            selectedType: null,
            offerType: null
        }));
    };

    const handleCoinCashOffer = (event) => {
        if (bookingData.datesType === 'fixed') {
            if (bookingData?.isReserved || bookingData.isInstallment) {
                toast.warning('Offer can be applied only for full payment');
                return;
            }
        } else if (bookingData.amountPaid.isReserved || bookingData.amountPaid.isInstallment) {
            toast.warning('Offer can be applied only for full payment');
            return;
        }
        const checked = event.target.checked;
        if (!checked) {
            setBookingData((prevState) => {
                return {
                    ...prevState,
                    totalAmo: finalPayable + cashToRedeem
                };
            });
        }
        setCashToRedeem(0);
        setIsCashCoin(checked);
        setSelectedType('');
        setAmount(0);
    };

    // const customTotalAmount =
    //     bookingData?.totalCustomAmountBeforeDiscount -
    //     bookingData?.customDiscountAmount +
    //     Math.round(bookingData?.totalCustomAmount * 0.05);

    return (
        <div ref={bookingTabRef} className={`tripBookingTab ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <div className='tripBookingPriceDiv'>
                <div className='toggleOverlay' onClick={toggleExpand} />
                <div className='internalFlex'>
                    <h2 className='reviewBoSumH1'>Price Summary</h2>
                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>₹{finalPayable || bookingData.totalCustomAmount}</p>
                    </div>
                </div>
                <button onClick={toggleExpand} className='collapseArrow'>
                    <Chevron width={24} height={24} />
                </button>
                <button className='reviewButton reviewBoSumSmallConfirm' type='button' onClick={reviewConfirm}>
                    Confirm
                </button>
            </div>

            <div className='tripBookingSubTab'>
                {/* {bookingData?.isReserved &&
                bookingData.isInstallment &&
                bookingData.amountPaid.isReserved &&
                bookingData.amountPaid.isInstallment ? (
                    <></>
                ) : (
                    !isCashCoin && (
                        <>
                            <label className='tripBookDatalabel2'>Offer Code</label>
                            <div className='tripBookOfferDiv' style={{ marginBottom: '10px' }}>
                                <input
                                    type='text'
                                    placeholder='Enter promo code'
                                    name='offerCode'
                                    value={offerCode}
                                    className='tripBookOfferIn'
                                    onChange={(e) => handlePromoCode(e)}
                                />
                                <button
                                    className='tripBookOfferBtn'
                                    onClick={() => {
                                        offerApplyTrip(
                                            offerCode,
                                            handleApplyOffer,
                                            setBookingData,
                                            bookingData,
                                            setOfferType,
                                            isAuthenticated
                                        );
                                    }}
                                >
                                    Apply
                                </button>
                            </div>
                            {bookingData?.offerCode && (
                                <div
                                    className='tripBookTotalDiv'
                                    style={{
                                        marginBottom: '-10px',
                                        marginTop: '-10px',
                                        paddingRight: '8px',
                                        paddingLeft: '8px'
                                    }}
                                >
                                    <p className='tripBookTotalText'>{bookingData?.offerCode}</p>
                                    <p
                                        className='tripBookTotalText'
                                        style={{ color: 'white', cursor: 'pointer' }}
                                        onClick={() => {
                                            handleRemoveOffer();
                                        }}
                                    >
                                        <img src={Remove} alt='remove'></img>
                                    </p>
                                </div>
                            )}
                        </>
                    )
                )}
                {!bookingData.offerApplied && !isCashCoin && (
                    <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '-6px' }}>or</div>
                )}
                {(!bookingData.offerApplied || bookingData.offerType === 'cashOrcoin') && (
                    <>
                        <div id='org-checkbox-div' style={{ marginTop: '5px', marginLeft: '-5px' }}>
                            <input type='checkbox' id='coinCash' checked={isCashCoin} onChange={handleCoinCashOffer} />
                            <label
                                htmlFor='coinCash'
                                id='tripReserveLabel'
                                style={{ fontWeight: '500', paddingTop: '7px' }}
                            >
                                Use coins or cash
                            </label>
                        </div>
                        {isCashCoin && (
                            <>
                                <div className='paymentTypeWrapper'>
                                    <div className='paymentTypeDiv'>
                                        <input
                                            type='radio'
                                            name='offerType'
                                            value='cash'
                                            checked={selectedType === 'cash'}
                                            onChange={(e) => {
                                                setSelectedType(e.target.value);
                                                setAmount(0);
                                            }}
                                            disabled={bookingData.offerAmo > 0}
                                        />

                                        <label className='tripBookPaymentType'>
                                            Cash : {loggedInUser?.rewards?.[1]?.count || 0}
                                        </label>
                                    </div>

                                    <div className='paymentTypeDiv'>
                                        <input
                                            type='radio'
                                            name='offerType'
                                            value='coins'
                                            checked={selectedType === 'coins'}
                                            onChange={(e) => {
                                                setSelectedType(e.target.value);
                                                setAmount(0);
                                            }}
                                            disabled={bookingData.offerApplied}
                                        />
                                        <label className='tripBookPaymentType'>
                                            Coins : {loggedInUser?.rewards?.[0]?.count || 0}
                                        </label>
                                    </div>
                                </div>
                                {bookingData.offerAmo > 0 ? (
                                    <div
                                        className='tripBookTotalDiv'
                                        style={{
                                            marginBottom: '-10px',
                                            marginTop: '-10px',
                                            paddingRight: '8px',
                                            paddingLeft: '8px'
                                        }}
                                    >
                                        <p className='tripBookTotalText'>
                                            ₹{bookingData.offerAmo} {selectedType} redeemed
                                        </p>
                                        <p
                                            className='tripBookTotalText'
                                            style={{ color: 'white', cursor: 'pointer' }}
                                            onClick={handleRemoveOffer}
                                        >
                                            <img src={Remove} alt='remove' />
                                        </p>
                                    </div>
                                ) : (
                                    <div className='tripBookOfferDiv' style={{ marginBottom: '10px' }}>
                                        <input
                                            type='number'
                                            min='0'
                                            className='tripBookOfferIn'
                                            value={amount}
                                            placeholder='Enter coins or cash to redeem'
                                            onChange={(e) => {
                                                const value = Number(e.target.value);

                                                if (!selectedType) {
                                                    toast.warning('Please select coins or cash first.');
                                                    return;
                                                }

                                                // Get reward index & max allowed value
                                                const rewardIndex = selectedType === 'cash' ? 1 : 0;
                                                const maxValue = loggedInUser?.rewards?.[rewardIndex]?.count ?? 0;

                                                // Validate input
                                                if (isNaN(value) || value < 0) {
                                                    toast.warning('Enter a valid positive number.');
                                                    return;
                                                }

                                                // Prevent typing above max, just show a warning
                                                if (value > maxValue) {
                                                    toast.warning(`You can use up to ${maxValue} ${selectedType}.`);
                                                    return;
                                                }

                                                // Remove leading zeros and update normally
                                                const cleanValue = value === '' ? '' : String(Number(value));
                                                setAmount(cleanValue);
                                            }}
                                        />

                                        <button
                                            className='tripBookOfferBtn'
                                            onClick={() => {
                                                handleCashOrCoins();
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )} */}
                {bookingData?.datesType === 'custom' && bookingData?.amountPaid?.isReserved ? (
                    <div className='tripBookDataInput'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹{bookingData?.reservePrice} x {bookingData?.people}
                            </p>
                            <p className='tripBookPrice'>₹{bookingData?.amountPaid.reserve}</p>
                        </div>
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>- ₹{0}</p>
                        </div> */}
                        {/* {bookingData.offerCode && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{bookingData?.offerAmo}</p>
                            </div>
                        )} */}
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Tax</p>
                            <p className='tripBookOfferText'>
                                + ₹{Math.round(bookingData?.customBooking?.amount?.peopleAmo * 0.05)}
                            </p>
                            <p className='tripBookOfferText'>+ 0</p>
                        </div> */}
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Convinience Fee</p>
                            <p className='tripBookOfferText'>+ ₹{reserveConvenienceFee}</p>
                        </div>
                        {paymentType === 'UPI' && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>UPI Offers</p>
                                <p className='tripBookOfferText'>- ₹{reserveConvenienceFee}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{reservePrice}</p>
                        </div>
                        <span></span>
                        <button
                            type='button'
                            className='reviewBoSumChangeBtn grayBtn'
                            onClick={() => {
                                resetOffers();
                                setNavDetails(true);
                            }}
                        >
                            Change Details
                        </button>
                    </div>
                ) : bookingData?.datesType === 'custom' ? (
                    <div className='tripBookDataInput'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>₹{getHikedPrice(bookingData?.amountPaid?.actual)}</p>
                            <p className='tripBookPrice'>₹{getHikedPrice(bookingData?.amountPaid?.actual)}</p>
                        </div>

                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>
                                - ₹{Math.round(getHikedPrice(bookingData?.amountPaid?.actual) * 0.2)}
                            </p>
                        </div>
                        {((isCashCoin && bookingData.offerAmo > 0) || bookingData.offerCode) && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{offerAmount}</p>
                            </div>
                        )}
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Tax</p>
                            <p className='tripBookOfferText'>+ ₹{Math.round(bookingData?.amountPaid?.tax)}</p>
                        </div>

                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Convinience Fee</p>
                            <p className='tripBookOfferText'>+ ₹{convenienceFee}</p>
                        </div>

                        {paymentType === 'UPI' && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>UPI Offers</p>
                                <p className='tripBookOfferText'>- ₹{convenienceFee}</p>
                            </div>
                        )}

                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{finalPayable}</p>
                        </div>

                        <button
                            type='button'
                            className='reviewBoSumChangeBtn grayBtn'
                            onClick={() => {
                                resetOffers();
                                setNavDetails(true);
                            }}
                        >
                            Change Details
                        </button>
                    </div>
                ) : bookingData.isReserved ? (
                    <div className='tripBookDataInput'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹{bookingData?.reservePrice} x {bookingData?.people}
                            </p>
                            <p className='tripBookPrice'>₹{bookingData?.reservePrice * bookingData?.people}</p>
                        </div>
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>- ₹{0}</p>
                        </div> */}
                        {bookingData.offerCode && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{offerAmount}</p>
                            </div>
                        )}
                        {/* <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Tax</p>
                            <p className='tripBookOfferText'>+ ₹{Math.round(bookingData?.peopleAmo * 0.05)}</p>
                        </div> */}
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Convinience Fee</p>
                            <p className='tripBookOfferText'>+ ₹{reserveConvenienceFee}</p>
                        </div>
                        {paymentType === 'UPI' && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>UPI Offers</p>
                                <p className='tripBookOfferText'>- ₹{reserveConvenienceFee}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{reservePrice}</p>
                        </div>
                        <span></span>
                        <button
                            type='button'
                            className='reviewBoSumChangeBtn grayBtn'
                            onClick={() => {
                                resetOffers();
                                setNavDetails(true);
                            }}
                        >
                            Change Details
                        </button>
                    </div>
                ) : bookingData.isInstallment ? (
                    <div className='tripBookDataInput'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹{bookingData?.installmentPrice} x {bookingData?.people}
                            </p>
                            <p className='tripBookPrice'>₹{bookingData?.peopleAmo}</p>
                        </div>
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Convinience Fee</p>
                            <p className='tripBookOfferText'>+ ₹{convenienceFee}</p>
                        </div>
                        {paymentType === 'UPI' && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>UPI Offers</p>
                                <p className='tripBookOfferText'>- ₹{convenienceFee}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{reservePrice}</p>
                        </div>
                        <span></span>
                        <button
                            type='button'
                            className='reviewBoSumChangeBtn grayBtn'
                            onClick={() => {
                                resetOffers();
                                setNavDetails(true);
                            }}
                        >
                            Change Details
                        </button>
                    </div>
                ) : (
                    <div className='tripBookDataInput'>
                        <div className='tripPriceCal'>
                            <p className='tripBookPrice'>
                                ₹{getHikedPrice(bookingData.actualPrice)} x {bookingData?.people}
                            </p>
                            <p className='tripBookPrice'>₹{getHikedPrice(bookingData?.peopleAmo)}</p>
                        </div>
                        {bookingData?.roomAmount > 0 && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Room</p>
                                <p className='tripBookOfferText'>+ ₹{Math.round(bookingData?.roomAmount)}</p>
                            </div>
                        )}
                        {bookingData?.vehiclePrice > 0 && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Vehicle</p>
                                <p className='tripBookOfferText'>+ ₹{Math.round(bookingData?.vehiclePrice)}</p>
                            </div>
                        )}
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Discount</p>
                            <p className='tripBookOfferText'>
                                - ₹{Math.round(getHikedPrice(bookingData?.peopleAmo) * 0.2)}
                            </p>
                        </div>
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Tax</p>
                            <p className='tripBookOfferText'>+ ₹{Math.round(bookingData?.peopleAmo * 0.05)}</p>
                        </div>
                        {(bookingData?.offerAmo > 0 || bookingData.offerCode) && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Offer</p>
                                <p className='tripBookOfferText'>- ₹{offerAmount}</p>
                            </div>
                        )}

                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Convinience Fee</p>
                            <p className='tripBookOfferText'>+ ₹{convenienceFee}</p>
                        </div>
                        {paymentType === 'UPI' && (
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>UPI Offers</p>
                                <p className='tripBookOfferText'>- ₹{convenienceFee}</p>
                            </div>
                        )}
                        <div className='tripBookTotalDiv'>
                            <p className='tripBookTotalText'>Total:</p>
                            <p className='tripBookTotalText'>₹{finalPayable}</p>
                        </div>
                        <span></span>
                        <button
                            type='button'
                            className='reviewBoSumChangeBtn grayBtn'
                            onClick={() => {
                                resetOffers();
                                setNavDetails(true);
                            }}
                        >
                            Change Details
                        </button>
                    </div>
                )}
                <div>
                    {remainingAmount > 0 && (
                        <div className='leftAmountDiv'>
                            Remaining amount to be paid on the trip Rs.
                            {remainingAmount} (including tax)
                        </div>
                    )}
                    {!bookingData.isReserved && !bookingData?.amountPaid?.isReserved && !bookingData?.isInstallment && (
                        <div className='leftAmountDiv'>
                            You will get{' '}
                            {Math.round(
                                (bookingData.actualPrice * bookingData.people + bookingData.roomAmount) * 0.1
                            ) || Math.round(bookingData?.amountPaid?.actual * 0.1)}{' '}
                            coins after this trip{' '}
                        </div>
                    )}
                    <p className='tripBookPriceText'>Choose Payment Type</p>
                    <div className='paymentTypeWrapper'>
                        <div className='paymentTypeDiv'>
                            <input
                                type='radio'
                                name='paymentType'
                                id='upi'
                                value='UPI'
                                checked={paymentType === 'UPI'}
                                onChange={(e) => {
                                    localStorage.setItem('paymentTypeChange', 'false');
                                    setPaymentType(e.target.value);
                                    setBookingData((prev) => ({
                                        ...prev,
                                        paymentType: e.target.value
                                    }));
                                }}
                            />
                            <label htmlFor='upi' className='tripBookPaymentType'>
                                UPI
                            </label>
                        </div>
                        <div className='paymentTypeDiv'>
                            <input
                                type='radio'
                                name='paymentType'
                                id='others'
                                value='OTHERS'
                                checked={paymentType === 'OTHERS'}
                                onChange={(e) => {
                                    localStorage.setItem('paymentTypeChange', 'false');
                                    setPaymentType(e.target.value);
                                    setBookingData((prev) => ({
                                        ...prev,
                                        paymentType: e.target.value
                                    }));
                                }}
                            />
                            <label htmlFor='others' className='tripBookPaymentType'>
                                Others
                            </label>
                        </div>
                    </div>
                    {paymentType === 'UPI' && (
                        <span className='reviewBoSumCondition'>*UPI Offers - Save up to ₹1000</span>
                    )}
                </div>
                <div className='tripBookBtnDiv'>
                    <p className='reviewBoSumCondition'>
                        By clicking on the Confirm button, You accept our{' '}
                        <a href='/terms' target='_blank' rel='noopener noreferrer'>
                            Terms & Conditions
                        </a>
                        ,{' '}
                        <a href='/cancellation-policy' target='_blank' rel='noopener noreferrer'>
                            Cancellation Policy
                        </a>
                        , and{' '}
                        <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>
                            Privacy Policy
                        </a>
                    </p>

                    <button className='reviewButton reviewBoSumConfirm' type='button' onClick={reviewConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}
